<ng-container *ngIf="test">
  <ct-language-report *ngIf="test.testModel.id === 24" [test]="test"></ct-language-report>
  <ct-reasoning-report *ngIf="test.testModel.id === 25" [test]="test"></ct-reasoning-report>
  <ct-digital-report *ngIf="test.testModel.id === 26" [test]="test"></ct-digital-report>
  <ct-adn-report *ngIf="utilsService.ADNTestModelIds.includes(test.testModel.id)" [test]="test"></ct-adn-report>
</ng-container>
